export const BREAK_POINT_WIDTH = '768px';
export const BREAK_POINT_SAFE_MIN_WIDTH = '769px';
export const BREAK_POINT_LARGE__WIDTH = '992px';
export const BREAK_POINT_LARGE_SAFE_MIN_WIDTH = '993px';
